(() => {
  const SELECTOR = 'variant-selects, .swatch__button, .radio__button, [data-product-options]';
  const LOCK_MS = 1600;
  const proto = Window.prototype;
  const nativeScrollTo = proto.scrollTo;
  const nativeScroll = proto.scroll;

  let lockedY = null;
  let unlockTimer = null;
  let page = null;
  let previousPageMinHeight = '';

  function parseTop(arg1, arg2) {
    if (arg1 && typeof arg1 === 'object') return arg1.top;
    if (typeof arg2 === 'number') return arg2;
    if (typeof arg1 === 'number') return arg1;
    return null;
  }

  function guardedScrollTo(arg1, arg2) {
    if (lockedY !== null) {
      const top = parseTop(arg1, arg2);
      if (typeof top === 'number' && top <= 2) return;
      return nativeScrollTo.call(this, 0, lockedY);
    }
    return nativeScrollTo.apply(this, arguments);
  }

  function guardedScroll(arg1, arg2) {
    if (lockedY !== null) {
      const top = parseTop(arg1, arg2);
      if (typeof top === 'number' && top <= 2) return;
      return nativeScroll.call(this, 0, lockedY);
    }
    return nativeScroll.apply(this, arguments);
  }

  proto.scrollTo = guardedScrollTo;
  proto.scroll = guardedScroll;

  function freezeGalleryLayout() {
    page = document.querySelector('.product__page');
    if (!page) return;
    previousPageMinHeight = page.style.minHeight;
    page.style.minHeight = `${page.offsetHeight}px`;
  }

  function releaseGalleryLayout() {
    if (!page) return;
    page.style.minHeight = previousPageMinHeight;
    page = null;
  }

  function unlock() {
    lockedY = null;
    window.scrollTo = nativeScrollTo;
    window.scroll = nativeScroll;
    document.documentElement.classList.remove('variant-scroll-locked');
    releaseGalleryLayout();
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
  }

  function lock() {
    lockedY = window.scrollY;
    window.scrollTo = guardedScrollTo;
    window.scroll = guardedScroll;
    document.documentElement.classList.add('variant-scroll-locked');
    freezeGalleryLayout();
    if (unlockTimer) clearTimeout(unlockTimer);
    unlockTimer = setTimeout(unlock, LOCK_MS);
  }

  const onVariantInteract = (event) => {
    if (!event.target.closest(SELECTOR)) return;
    lock();
  };

  document.addEventListener('click', onVariantInteract, true);
  document.addEventListener('change', onVariantInteract, true);
  window.addEventListener('wheel', unlock, {passive: true});
  window.addEventListener('touchmove', unlock, {passive: true});
})();
